import { api } from './client';
import type { Page } from './catalogs';

export interface FundReceiptItem {
  id: string;
  line_number: number;
  sick_calculation_id: string | null;
  employee_id: string | null;
  amount: string;
}

export interface FundReceipt {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  period_year: number;
  period_month: number;
  bank_account_id: string | null;
  fund_marker: string;
  total_amount: string;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  comment: string | null;
  items: FundReceiptItem[];
}

export interface FundReceiptListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  period_year: number;
  period_month: number;
  fund_marker: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
}

export interface FundReceiptCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  period_year: number;
  period_month: number;
  bank_account_id?: string | null;
  fund_marker?: string;
  comment?: string | null;
  items: Array<{ sick_calculation_id?: string | null; employee_id?: string | null; amount: string }>;
}

export interface FundDebtItem {
  sick_calculation_id: string;
  employee_id: string | null;
  amount: string;                    // залишок до відшкодування
  document_number?: string | null;   // № лікарняного
  employee_name?: string | null;
  accrued?: string | null;           // нараховано (pfu)
  received?: string | null;          // вже отримано
}
export interface FundDebtResult {
  period_year: number;
  period_month: number;
  fund_marker: string;
  debt_amount: string;
  items: FundDebtItem[];
}

export type FundReceiptUpdate = Partial<Omit<FundReceiptCreate, 'organization_id'>>;

export const fundReceipts = {
  list: (params?: { organization_id?: string; posted?: boolean; limit?: number }) =>
    api.get<Page<FundReceiptListItem>>('/fund-receipts', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<FundReceipt>(`/fund-receipts/${id}`).then((r) => r.data),
  create: (payload: FundReceiptCreate) =>
    api.post<FundReceipt>('/fund-receipts', payload).then((r) => r.data),
  update: (id: string, payload: FundReceiptUpdate) =>
    api.patch<FundReceipt>(`/fund-receipts/${id}`, payload).then((r) => r.data),
  post: (id: string) =>
    api.post<FundReceipt>(`/fund-receipts/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<FundReceipt>(`/fund-receipts/${id}/unpost`).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/fund-receipts/${id}`).then(() => undefined),
  fundDebt: (params: { organization_id: string; period_year: number; period_month: number }) =>
    api.get<FundDebtResult>('/fund-receipts/fund-debt', { params }).then((r) => r.data),
};
